import Farm from "../Assets/Images/Pagination/farm.jpeg";
import OMG from "../Assets/Images/Pagination/OMG.jpeg";
import Beaches from "../Assets/Images/Pagination/Beaches.jpeg";
import Lakefront from "../Assets/Images/Pagination/Lakefront.jpeg";
import Tropical from "../Assets/Images/Pagination/Tropical.jpeg";
import AmazingPools from "../Assets/Images/Pagination/Amazingpools.jpeg";
import AmazingViews from "../Assets/Images/Pagination/Amazingviews.jpeg";
import SharedHomes from "../Assets/Images/Pagination/Sharedhomes.jpeg";
import TinyHomes from "../Assets/Images/Pagination/Tinyhomes.jpeg";
import Mansions from "../Assets/Images/Pagination/Mansions.jpeg";
import NationalParks from "../Assets/Images/Pagination/Nationalparks.jpeg";
import Islands from "../Assets/Images/Pagination/Islands.jpeg";
import Beachfront from "../Assets/Images/Pagination/Beachfront.jpeg";
import Countryside from "../Assets/Images/Pagination/Countryside.jpeg";
import Design from "../Assets/Images/Pagination/Design.jpeg";
import Arctic from "../Assets/Images/Pagination/Arctic.jpeg";

const paginationPics = [
  [Farm, "Farms"],
  [OMG, "OMG!"],
  [Beaches, "Beaches"],
  [Lakefront, "Lakefront"],
  [Tropical, "Tropical"],
  [AmazingPools, "Amazing pools"],
  [AmazingViews, "Amazing views"],
  [SharedHomes, "Shared homes"],
  [TinyHomes, "Tiny homes"],
  [Mansions, "Mansions"],
  [NationalParks, "National parks"],
  [Islands, "Islands"],
  [Beachfront, "Beachfront"],
  [Countryside, "Countryside"],
  [Design, "Design"],
  [Arctic, "Arctic"],
];

export default paginationPics;
